import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from 'toolkit/components/ToolkitPageLayout'
import { institution_relationship_placeholder } from 'assets'

const institutionSectionLinks = [
  {
    title: 'Sickle Cell Disease Team & Emergency Department Relationship',
    path: '/toolkit/institution/scd-team-ed-relationship',
    description:
      'Resources to foster collaboration between SCD teams and ED staff.',
    image: institution_relationship_placeholder, // Placeholder
    altText: 'SCD Team and ED Relationship'
  },
  {
    title: 'Resources for Building a Sickle Cell Infusion Clinic (IC)',
    path: '/toolkit/institution/building-ic-resources',
    description:
      'Guidance and tools for establishing and operating an SCD Infusion Clinic.',
    image: institution_relationship_placeholder, // Placeholder
    altText: 'Building an Infusion Clinic'
  }
]

export const InstitutionSectionPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' }
  ]

  return (
    <ToolkitPageLayout title="Institution Tools" breadcrumbs={breadcrumbs}>
      <div className="container mx-auto px-4 py-8">
        <p className="text-xl text-gray-700 mb-6 text-center">
          Partnering with your institution is a crucial step in enhancing care
          for individuals with Sickle Cell Disease. This section provides tools
          and resources to facilitate discussions and implement improvements at
          an institutional level.
        </p>
        <p className="text-lg text-gray-600 mb-12 text-center">
          Select a category below to explore specific resources:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {institutionSectionLinks.map((link) => (
            <Link
              key={link.title}
              to={link.path}
              className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out overflow-hidden flex flex-col border border-gray-200"
            >
              <img
                src={link.image}
                alt={link.altText}
                className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="p-8 flex-grow flex flex-col">
                <h3 className="text-2xl font-semibold text-[#142841] mb-3">
                  {link.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow">
                  {link.description}
                </p>
                <span className="inline-block mt-auto self-start bg-[#A6410A] text-white font-medium px-6 py-2.5 rounded-lg group-hover:bg-[#C25F0C] transition-colors duration-300">
                  Explore Resources
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link
            to="/toolkit"
            className="inline-block bg-[#3C2416] text-white font-semibold px-10 py-4 rounded-lg shadow-md hover:bg-[#5a3d2b] transition-colors duration-300"
          >
            Back to Toolkit Home
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
